theme.headerSearch = (function () {
  function searchOverlay(e) {
    // Tranaprent header
    // const headerHeight = document.querySelector('.header__area');
    // document.documentElement.style.setProperty('--header-height', `${headerHeight.clientHeight}px`);

    let input = e.querySelector('input[type="search"]');

    let drawerAction = (trigger, closeTrigger, wrapper) => {
    let offcanvasSearchTrigger = document.querySelectorAll(trigger),
        offcanvasSidebarSearch = document.querySelector(wrapper),
        offcanvasSearchClose = document.getElementById(closeTrigger);

    // STOP if the search wrapper doesn't exist on this page
    if (!offcanvasSidebarSearch) return; 

    offcanvasSearchTrigger.forEach((singleTrigger) => {
      if (singleTrigger) {
        singleTrigger.addEventListener("click", (event) => {
          event.preventDefault();
          offcanvasSidebarSearch.classList.add("active");
          document.querySelector("body").classList.add("added__overlay_search");
          // ... rest of your code
        });
      }
    });
  };

    drawerAction(
      ".header__actions_btn--search",
      "search__close_btn",
      "#predictive__search_overlay"
    );
  }
  return searchOverlay;
})();
